/* script */
//
//
//

// Components
import UploadManager from 'shared/ui/components/uploader/UploadManager.vue';
import UploadModal from 'shared/ui/components/uploader/UploadModal.vue';
// Constants
import { MEDIA_MAX_FILE_SIZE_IN_BYTES } from 'libs/services/media';
import VttPicker from 'shared/ui/components/form-components/pickers/VttPicker.vue';

const __vue_script__ = {
    name: 'UploadLauncher',

    components: {
        UploadManager,
        VttPicker
    },

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            handler: null,
            workerScope: null,
            worker: null
        };
    },

    mounted() {
        this.handler = (params = {}) => {

            const { detail } = params;
            const { customModal } = detail;
            console.info('[UploadLauncher] New event received:', detail);

            if (!this.worker) {
                this.initWorker();
            }
            if (customModal?.modalComponent === 'VttPicker') {
                const { fpType, assetId, uploadedSubtitleFiles, onSubmitHook } = customModal;
                return this.$modal.show(VttPicker, {
                    name: 'closed_captions',
                    languages: this.event?.languages,
                    event: this.event,
                    scope: 'closed-captions',
                    fpType,
                    assetId,
                    uploadedSubtitleFiles,
                    worker: this.worker,
                    pageWorker: this.worker,
                    pageWorkerScope: this.workerScope,
                    onSubmitHook
                }, {
                    classes: 'small',
                    height: 'auto',
                    clickToClose: false
                });
            }

            const {
                scope,
                supportedMimes,
                context: data,
                modalTitle,
                modalSubtitle,
                modalSubtitleAsHtml,
                modalWarning,
                fpType,
                maxSize,
                attachmentSpecs,
                assetId,
                attachmentNamesGenerator,
                parentDocId
            } = detail;
            const { event, worker } = this;
            const props = {
                scope,
                data,
                event,
                worker,
                supportedMimes,
                modalTitle,
                modalSubtitle,
                subtitleAsHtml: modalSubtitleAsHtml,
                modalWarning,
                fpType,
                assetId,
                maxSize: maxSize || MEDIA_MAX_FILE_SIZE_IN_BYTES,
                attachmentSpecs,
                attachmentNamesGenerator,
                parentDocId
            };

            this.$modal.show(UploadModal, props, {
                height: 'auto',
                reset: true
            });
        };

        window.addEventListener('start-uploader', this.handler);
    },

    beforeDestroy() {
        this.worker = null;
        this.workerScope = null;
        window.removeEventListener('start-uploader', this.handler);
    },

    methods: {
        initWorker() {
            console.debug('[UploadLauncher] Initializing the worker');

            /** @type {WorkerOptions} */
            const workerOptions = {
                name: 'spotme-big-file-upload',
                credentials: 'include'
            };

            // Safari (at time of writing) does not support SharedWorkers, hence
            // we provide here a simple Worker instead.
            if (!window.SharedWorker && window.Worker) {

                this.worker = new Worker(`${window.BSTG.extLibs}/uploader${window.BSTG.scriptSuffix}`, workerOptions);
                this.workerScope = this.worker;

            } else if (window.SharedWorker) {

                this.worker = new SharedWorker(`${window.BSTG.extLibs}/uploader${window.BSTG.scriptSuffix}`, workerOptions);
                this.workerScope = this.worker.port;

            }

            if (!this.worker) {
                console.error('[UploadLauncher] Workers not supported.');
            }

            this.worker.onerror = (event) => console.error('[UploadLauncher] Could not initialize uploader worker.', event);
            // needed for .addEventListener('message') to be triggered in child components
            this.workerScope.onmessage = () => {};
        },

        terminate(reason) {
            console.info('[UploadLauncher] Terminating the worker (%s)', reason);
            this.workerScope.postMessage({ command: 'kill' });

            if (this.workerScope instanceof MessagePort) {
                this.workerScope.close();
            } else {
                this.workerScope.terminate();
            }
            this.workerScope = null;
            this.worker = null;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-manager',{attrs:{"worker":_vm.worker,"worker-scope":_vm.workerScope,"event":_vm.event},on:{"terminate":_vm.terminate}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UploadLauncher.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__